import { render, staticRenderFns } from "./binding6.vue?vue&type=template&id=497a47a2&scoped=true&"
import script from "./binding6.vue?vue&type=script&lang=js&"
export * from "./binding6.vue?vue&type=script&lang=js&"
import style0 from "./binding6.vue?vue&type=style&index=0&id=497a47a2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497a47a2",
  null
  
)

export default component.exports